import { ReactElement } from 'react';

import { AlertColor } from '@mui/material';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export function showSnackbarSuccess(message: string | ReactElement, toastId?: string) {
    return showSnackbar('success', message, toastId);
}

export function showSnackbarError(message: string | ReactElement, toastId?: string) {
    return showSnackbar('error', message, toastId);
}

export function showSnackbarWarning(message: string | ReactElement, toastId?: string) {
    return showSnackbar('warning', message, toastId);
}

export function showSnackbarInfo(message: string | ReactElement, toastId?: string) {
    return showSnackbar('info', message, toastId);
}

export function showSnackbar(severity: AlertColor, message: string | ReactElement, toastId?: string) {
    return toast(message, {
        toastId,
        autoClose: 5000,
        closeButton: true,
        closeOnClick: false,
        draggable: false,
        hideProgressBar: false,
        pauseOnFocusLoss: false,
        pauseOnHover: true,
        position: 'top-right',
        progress: undefined,
        theme: 'light',
        type: severity,
    });
}
